<template>
  <div id="top" class="mainWrapper">
    <!--nav-->
    <head-nav v-bind:gray="gray" v-bind:pos="'fixed'"></head-nav>
    <!--container-->
    <div class="innerWrapper">
      <h1>Construction updates</h1>
      <div style="padding:0 0.24rem">
        <div class="otherWrapper">
          <div v-for="(con, ix) in datum" :key="ix" class="other">
            <div class="top">
              <div class="tit">
                <h3>{{ con.title }}</h3>
                <h4>Posted {{ con.createTime }}</h4>
              </div>
            </div>
            <ul class="middle" style="margin-top: 1rem;">
              <li
                v-for="(img, i) in con.imgLst"
                :key="i"
                :style="{ backgroundImage: 'url(' + img + ')' }"
              ></li>
              <div
                v-if="con.imgLst && con.imgLst.length > 5"
                class="more"
                @click="toDtl(con.constructionId)"
              >
                <p>+ {{ con.imgLst.length - 4 }} More</p>
              </div>
            </ul>
            <div class="bom">
              <p v-html="con.description"></p>
              <div class="link" @click="toDtl(con.constructionId)">
                VIEW FULL UPDATE
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--footer-->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      datum: [],
      gray: true
    };
  },
  created() {
    var that = this;
    that.getLst({ params: that.$route.params.id, callback: that.callback });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    ...mapActions("construction", ["getLst"]),
    callback(res) {
      var that = this;
      if (res.data.code == 0) {
        res.data.data.forEach(v => {
          if (v.imageUrl) {
            if (v.imageUrl.indexOf(",") !== -1) {
              v.imgLst = v.imageUrl.split(",");
            } else {
              v.imgLst = [v.imageUrl];
            }
          }
          v.createTime = that.$box.formatTimestamp(v.createTime);
        });
        that.datum = res.data.data;
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      }
    },
    toDtl(res) {
      var that = this;
      that.$router.push(
        `/account/inner/${res}/list/${that.$route.params.id}/0/0`
      );
    }
  },
  components: {
    headNav,
    footNav
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  padding-top: 1.52rem;
  box-sizing: border-box;

  h1 {
    font-size: 0.56rem;
    color: #2a2929;
    line-height: 0.68rem;
    margin-bottom: 0.8rem;
    font-family: ProximaNova-Semibold;
    margin-left: 0.24rem;
  }
}

.otherWrapper {
  width: 100%;
  margin: 0 auto 0.68rem auto;

  .other {
    width: 100%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    border: 1px solid rgba(247, 247, 250, 1);
    margin-bottom: 0.6rem;
    box-sizing: border-box;
    padding: 0.48rem 0.32rem;

    .top {
      margin-bottom: 0.48rem;
      width: 100%;

      .tit {
        float: left;
        width: 100%;

        h3 {
          font-size: 0.34rem;
          line-height: 0.36rem;
          color: #333333;
          margin-bottom: 0.08rem;
          font-family: ProximaNova-Semibold;
        }

        h4 {
          width: 100%;
          font-size: 0.28rem;
          line-height: 0.34rem;
          color: #8e8c8f;
        }
      }
    }

    .middle {
      margin-bottom: 0.48rem;
      height: 3.16rem;
      position: relative;

      li {
        position: absolute;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        border-radius: 3px;
        background-color: #f5f6f8;
        width: 0;
        height: 0;
        overflow: hidden;
      }

      li:nth-child(1) {
        width: 3.16rem;
        height: 3.16rem;
        left: 0;
        top: 0;
      }

      li:nth-child(2) {
        left: 3.2rem;
        top: 0;
        width: 1.54rem;
        height: 1.54rem;
      }

      li:nth-child(3) {
        right: 0;
        top: 0;
        width: 1.54rem;
        height: 1.54rem;
      }

      li:nth-child(4) {
        left: 3.2rem;
        bottom: 0;
        width: 1.54rem;
        height: 1.54rem;
      }

      li:nth-child(5) {
        right: 0;
        bottom: 0;
        width: 1.54rem;
        height: 1.54rem;
      }

      .more {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 1.54rem;
        height: 1.54rem;
        background: rgba(0, 0, 0, 0.6);
        z-index: 1;
        cursor: pointer;

        p {
          font-size: 0.28rem;
          text-align: center;
          line-height: 1.54rem;
          color: #fff;
        }
      }
    }

    .bom {
      height: 50px;
      overflow: hidden;
      position: relative;

      p {
        font-size: 14px;
        line-height: 27px;
        color: #3f3f46;
      }

      .link {
        // position: absolute;
        // bottom: 3px;
        // right: 0;
        // font-size: 16px;
        // color: #2CCA73;
        // text-decoration: underline;
        // background:#fff;
        // box-shadow: -29px 0 13px -1px rgba(252,255,255,1);
        // cursor: pointer;
        position: absolute;
        bottom: 0.03rem;
        right: 0;
        width: 2.8rem;
        font-size: 0.25rem;
        color: #2cca73;
        text-decoration: underline;
        background: #fff;
        box-shadow: -29px 0 13px -1px rgba(252, 255, 255, 1);
        cursor: pointer;
        word-break: keep-all;
      }
    }
  }
}

.swiper-button-prev {
  background-image: url("../../assets/p.png");
  background-size: 40px 40px;
  width: 40px;
  height: 40px;
  left: 15px;
}

.swiper-button-next {
  background-image: url("../../assets/n.png");
  background-size: 40px 40px;
  width: 40px;
  height: 40px;
  right: 15px;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/account/list.vue